/**
 * @brief Global Navigation Bar 컴포넌트
 * @details
 * @author hyekyoungKang
 * @date 2024-06-10
 * @version 0.0.1
 */

 import React from "react";
 import styles from "./Gnb.module.scss";
 import { Link, useLocation, useNavigate } from "react-router-dom";
 import clsx from "clsx";
 
 const Gnb = ({ navs, setCurrentNav }) => {
   const location = useLocation();
   const activeMenuValue = navs.find((menu) =>
     location.pathname.includes(menu.navi)
   )?.value;
 
   const handleTabClick = (activeMenuValue) => {
     setCurrentNav(activeMenuValue);
   };
 
   return (
     <div className={styles.container}>
       <ul className={styles.menu}>
         {navs.map((item, index) => {
           const isActive =
             item.value === activeMenuValue && activeMenuValue!== "/";
           return (
             <Link to={item.navi} key={item.id}>
               <li
                 key={item.id}
                 className={clsx(styles.menuName, {
                   [styles.selectedName]: isActive,
                 })}
                 onClick={() => handleTabClick(item.value)}
                 style={{ marginLeft: index!== 0? "60px" : "0px" }}
               >
                 {item.name}
               </li>
             </Link>
           );
         })}
       </ul>
     </div>
   );
 };
 
 export default Gnb;
 